import { Badge, Colour, ListItem } from '@ukpostbox/frontend-framework';

type HarmonySearchDetailedType = {
	commodityHeading?: any;
	lookupCallback: (code: string) => void;
	selectedCallback: (code: string) => void;
};

function HarmonySearchDetailed(props: HarmonySearchDetailedType) {
	/*
    * code: "7201100000"
        declarable: false
        description: "Non-alloy pig iron containing by weight 0,5 % or less of phosphorus"
        endDate: null
        parentSid: null
        sid: 44813
        startDate: "1972-01-01T00:00:00Z"
    * */
	return (
		<div>
			{props.commodityHeading?.commodities?.map((item: any) =>
				item.declarable ? (
					<ListItem
						hideArrow
						key={`commodityEntry${item.code}`}
						title={`${item.description.replace('/<br>/gi', '\n')}`}
						description={`${item.code}`}
						addonLeft={<Badge colour={Colour.Success} />}
						onClick={() => props.selectedCallback(item.code)}
					/>
				) : (
					<ListItem
						static
						hideArrow
						key={`commodityEntry${item.code}`}
						title={`${item.description.replace('/<br>/gi', '\n')}`}
					/>
				),
			)}
		</div>
	);
}

export { HarmonySearchDetailed };
